/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeleteAgreementsResponse = {
  vin: string;
  serviceId: string;
  birthDd: string;
  customerType: DeleteAgreementsResponse.customerType;
  agreeInfo: Array<'SAFE_DRIVING_SCORE' | 'CONNECTED_SERVICES' | 'TOTAL_DISTANCE_TRAVELED'>;
  corpRgstNo: string;
  taxId: string;
};
export namespace DeleteAgreementsResponse {
  export enum customerType {
    INDIVIDUAL = 'INDIVIDUAL',
    CORPORATE = 'CORPORATE',
    PRIVATE_BUSINESS = 'PRIVATE_BUSINESS',
    FOREIGNER = 'FOREIGNER',
    PUBLIC_INSTITUTION = 'PUBLIC_INSTITUTION',
  }
}

